import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useApp } from '../../context/AppContext';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const SearchOverlay = () => {
  const { isSearchOpen, setIsSearchOpen } = useApp();
  const [query, setQuery] = useState('');

  return (
    <AnimatePresence>
      {isSearchOpen && (
        <motion.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-parchment/98 z-[100] p-6 md:p-20"
        >
          <div className="max-w-4xl mx-auto">
            <div className="flex justify-between items-center mb-12">
              <span className="stamp-badge">Archive Search</span>
              <button 
                onClick={() => setIsSearchOpen(false)}
                className="p-2 hover:bg-cobalt/5 rounded-full"
                aria-label="Close Search"
              >
                <SafeIcon icon={FiIcons.FiX} className="text-3xl text-cobalt" />
              </button>
            </div>

            <div className="relative">
              <input 
                autoFocus
                type="text" 
                placeholder="Search systems, field notes, or gear..."
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                className="w-full bg-transparent border-b-2 border-cobalt/20 focus:border-cobalt py-6 text-3xl md:text-5xl font-serif italic outline-none text-cobalt placeholder:text-cobalt/10"
              />
              <SafeIcon icon={FiIcons.FiSearch} className="absolute right-0 top-1/2 -translate-y-1/2 text-4xl text-cobalt/20" />
            </div>

            <div className="mt-16 grid md:grid-cols-2 gap-12">
              <div>
                <h4 className="text-xs font-black uppercase tracking-[0.3em] text-amber mb-6">Trending Recon</h4>
                <div className="space-y-4">
                  {['Atlas Weekender', 'Compression Logic', 'Weather-Resistant Nylon', 'TSA Compliance'].map(term => (
                    <button key={term} className="block text-xl font-bold text-cobalt/60 hover:text-amber transition-colors">
                      {term}
                    </button>
                  ))}
                </div>
              </div>
              <div className="journal-border p-8 bg-white/50">
                <p className="text-sm font-serif italic text-ink-light leading-relaxed">
                  "Our search algorithm is trained on thousands of expedition reports to help you find the exact gear configuration for your specific destination workspace."
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SearchOverlay;